var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-page"},[_c('el-container',[_c('el-aside',{staticStyle:{"height":"100%"},attrs:{"width":"auto"}},[_c('LayoutMenu')],1),_c('el-container',[_c('el-header',{staticClass:"flex items-center",staticStyle:{"box-shadow":"0 4px 4px rgba(0, 21, 41, 0.08)"}},[_c('LayoutHeader')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }